import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useCartStore = defineStore('cart', () => {
  const items = ref(JSON.parse(localStorage.getItem('cart') || '[]'))

  const count = computed(() => items.value.length)

  function save() {
    localStorage.setItem('cart', JSON.stringify(items.value))
  }

  function add(part) {
    const existing = items.value.find((i) => i.id === part.id)
    if (existing) {
      existing.quantity += part.quantity ?? 1
    } else {
      items.value.push({ ...part })
    }
    save()
  }

  function remove(partId) {
    items.value = items.value.filter((i) => i.id !== partId)
    save()
  }

  function updateQuantity(partId, quantity) {
    const item = items.value.find((i) => i.id === partId)
    if (item) {
      item.quantity = Math.max(1, quantity)
      save()
    }
  }

  function clear() {
    items.value = []
    save()
  }

  return { items, count, add, remove, updateQuantity, clear }
})
